type Icon =
  | 'arrow-left'
  | 'chevron-down'
  | 'chevron-up'
  | 'cross'
  | 'plus'
  | 'plus-accordion'
  | 'minus-accordion'
  | 'heart'
  | 'logout'
  | 'cross-in-circle'

interface  Props {
  className?: string
  type: Icon
}

export const Icon = ({ className, type }: Props) => {

  let contents = null
  let width = "16"
  let height = "16"
  let viewBox = "0 0 16 16"

  switch (type) {
    case "arrow-left":
      contents = <path fill="currentColor" d="M5.25 3.144a.4.4 0 0 1 .615.512L2.253 8H14.4a.4.4 0 1 1 0 .8H2.254l3.61 4.343a.4.4 0 0 1-.614.512l-4.158-5a.4.4 0 0 1 0-.512l4.158-5Z"/>
      break
    // @TODO: Fix this later
    case "chevron-down":
      contents = <path fill="currentColor" d="M8.525 11.918a.5.5 0 0 1-.628-.065l-6.25-6.25a.5.5 0 1 1 .707-.707l5.896 5.897 5.896-5.897a.5.5 0 0 1 .708.707l-6.25 6.25-.079.065Z"/>
    case "chevron-up":
      contents = <path fill="currentColor" d="M7.475 4.082a.5.5 0 0 1 .628.065l6.25 6.25a.5.5 0 0 1-.707.707L7.75 5.207l-5.897 5.897a.5.5 0 1 1-.707-.707l6.25-6.25.079-.065Z"/>
      break
    case "cross":
      contents = <path fill="currentColor" d="M12.224 3.135a.45.45 0 0 1 .643 0 .465.465 0 0 1 0 .651L8.642 8.064l4.097 4.15a.465.465 0 0 1 0 .651.45.45 0 0 1-.643 0L8 8.715l-4.096 4.15a.45.45 0 0 1-.643 0 .465.465 0 0 1 0-.651l4.096-4.15-4.224-4.278a.465.465 0 0 1 0-.651.45.45 0 0 1 .643 0L8 7.413l4.224-4.278Z"/>
      break
    case "cross-in-circle":
      contents = <path fill="currentColor" d="M14.034 8A6.034 6.034 0 1 0 1.966 8a6.034 6.034 0 0 0 12.069 0Zm-3.963-2.755a.484.484 0 0 1 .684.683L8.683 7.999l2.004 2.005a.483.483 0 0 1-.683.682L7.999 8.682l-2.004 2.004a.483.483 0 1 1-.682-.682l2.003-2.005-2.071-2.071a.483.483 0 1 1 .683-.683l2.071 2.071 2.073-2.071ZM15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
      break  
    case "heart":
      contents = <path fill="#000" d="M10.778 1.013a3.2 3.2 0 0 1 .839.034h-.001c.399.058.78.189 1.132.368l.001.001c.522.268.998.656 1.354 1.148l.134.191c.128.194.238.398.33.607.117.261.22.54.294.83l.066.297v.003c.08.467.09.947.05 1.409v.003a5.638 5.638 0 0 1-.25 1.27 6.84 6.84 0 0 1-.456 1.061l-.002.004c-.28.526-.614 1.015-.96 1.475l-.003.004c-.262.34-.535.694-.828 1.031h.001c-.343.4-.705.788-1.073 1.164-.288.302-.584.593-.887.881-.393.385-.8.774-1.218 1.144-.314.284-.606.537-.882.816a.465.465 0 0 1-.088.119.464.464 0 0 1-.54.072.466.466 0 0 1-.176-.145c-.287-.294-.592-.558-.92-.856-.416-.368-.82-.753-1.211-1.134l-.45-.438a22.226 22.226 0 0 1-.44-.447 25.014 25.014 0 0 1-1.072-1.163 21.895 21.895 0 0 1-.829-1.034l-.003-.004c-.345-.46-.679-.95-.959-1.475l-.001-.003a6.805 6.805 0 0 1-.46-1.067l.001-.001a5.64 5.64 0 0 1-.248-1.263v-.004a5.55 5.55 0 0 1 .05-1.408V4.5c.073-.4.205-.78.362-1.13.122-.278.276-.546.462-.795.356-.492.832-.88 1.354-1.149h.002c.352-.18.732-.31 1.13-.368.287-.05.567-.057.84-.034l.269.032h.007l.168.033c.396.082.798.229 1.16.468l.005.003c.362.246.66.563.909.895.092.12.177.244.257.375.08-.132.165-.258.256-.38.25-.335.55-.653.914-.9l.005-.003c.414-.274.88-.427 1.328-.501l.008-.001.269-.032Zm.674.951a2.462 2.462 0 0 0-.805.003h-.001c-.35.058-.682.175-.96.358v-.001c-.253.173-.48.407-.685.683a3.437 3.437 0 0 0-.553 1.09.464.464 0 0 1-.897-.003 3.278 3.278 0 0 0-.548-1.071l-.005-.005a2.937 2.937 0 0 0-.69-.686 2.5 2.5 0 0 0-.962-.356 2.454 2.454 0 0 0-.798 0l-.019.002c-.287.04-.574.136-.854.278a2.902 2.902 0 0 0-1.027.87l-.005.006c-.141.19-.26.398-.357.617v.002c-.135.3-.24.607-.295.914a4.619 4.619 0 0 0-.04 1.164l.03.275c.025.18.057.358.1.53l.075.255.002.006c.098.307.239.614.396.916l.196.347c.206.344.439.677.686 1.006.198.258.39.509.588.75l.201.237.001.002c.165.191.335.38.508.568l.53.556.003.004c.138.145.279.287.422.43l.438.423.003.004c.195.19.391.38.59.565l.596.548.004.003.51.458c.055.05.109.102.164.154.233-.22.47-.426.686-.623l.003-.004a33.68 33.68 0 0 0 1.187-1.111l.003-.004c.298-.283.584-.565.86-.854l.004-.004c.359-.367.707-.742 1.036-1.124l.002-.002c.271-.312.528-.645.793-.99.328-.437.63-.883.878-1.349.158-.302.299-.609.396-.916l.002-.006c.112-.336.171-.69.206-1.061a4.622 4.622 0 0 0-.041-1.166 3.982 3.982 0 0 0-.294-.91l-.001-.004a3.145 3.145 0 0 0-.358-.616l-.004-.006a2.901 2.901 0 0 0-1.028-.87 2.71 2.71 0 0 0-.854-.278c-.006 0-.012-.003-.018-.004Z"/>
      break
    case "logout":
      contents = <path fill="#000" d="M7.815 10.615V3.202l-2.403 2.09a.381.381 0 0 1-.534-.034.373.373 0 0 1 .035-.53l3.032-2.635.056-.04a.381.381 0 0 1 .442.04l3.032 2.636a.373.373 0 0 1 .035.529.381.381 0 0 1-.534.035L8.572 3.202v7.413a.377.377 0 0 1-.378.376.377.377 0 0 1-.379-.376ZM15 13.382c0 .121-.028.25-.093.36a.5.5 0 0 1-.428.258H1.521a.5.5 0 0 1-.428-.257.718.718 0 0 1-.093-.361V8c0-.207.17-.376.379-.376s.378.169.378.376v5.25h12.486V8c0-.207.17-.376.378-.376.21 0 .379.169.379.376v5.382Z"/>
      break
    case "plus":
      contents = <path fill="currentColor" d="M8.168 1v6.166h6.165v1H8.168v6.167h-1V8.166H1v-1h6.168V1h1Z"/>
      break
    case "plus-accordion":
      width = "10"
      height = "10"
      viewBox = "0 0 10 10"
      contents = (
        <g>
          <path d="M5 0V10" stroke="currentColor" />
          <path d="M0 5L10 5" stroke="currentColor" />
        </g>
      )
      break
    case "minus-accordion":
      width = "10"
      height = "10"
      viewBox = "0 0 10 10"
      contents = <path d="M0 5L10 5" stroke="currentColor" />
      break
  }

  return (
    <svg
      className={className} 
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      {contents}
    </svg>
  )
}
